<div class="container main-container">
    <h3 class="page-title mb-2">Create token / Payment</h3>
    <iframe class="responsive-iframe" width="100%%" height="600px" frameBorder="0" [src]="urlSafe"></iframe>
</div>